import { Link } from 'gatsby';
import React from 'react';
import { StructuredText } from 'react-datocms';


function FooterMenu({ title, menu })
{

  return (
    <div>
      <h3 className="text-orange uppercase mb-8 font-semibold text-xl">{title}</h3>
      {title !== "Contact"
        ?
        <ul>
          {menu.map(block => (

            <li key={block.id} className="text-white">
              <Link to={"/" + block.url.slug} className="text-white hover:text-orange">{block.title}</Link>
            </li>

          ))}
        </ul>
        :
        <div className="text-white">
          <StructuredText data={menu[0].content[0].text} />
        </div>

      }


    </div>
  );
}

export default FooterMenu;